import { render } from "./HouseBottomMail.vue?vue&type=template&id=3762bb10"
import script from "./HouseBottomMail.vue?vue&type=script&lang=js"
export * from "./HouseBottomMail.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__